import React, {useState} from "react";
import QuestionCard from "./QuestionCard";
import {useExam} from "../../contexts/ExamContext";
import QuestionControl from "./QuestionControl";
import ExamHeader from "./ExamHeader";
import { useExamTimer } from "../../hooks/useExamTimer";


const ExamPage = ({onFinish, overlayRoot}) => {
    const {exam} = useExam();

    // timings
    const [startedAt] = useState(() => new Date());
    const { timeLeft } = useExamTimer(exam?.durationMinutes || 0);

    // prefer the fullscreen container when present
    const appendTo =
        overlayRoot?.current ||
        document.fullscreenElement ||
        document.querySelector(".custom-container") ||
        document.body;


    if (exam.finished) return <div>Sınav Tamamlandı</div>;

    return (

        <div className="relative w-full flex justify-content-center">
            <div className="relative" style={{width: "75%", minHeight: "400px"}}>
                <div className="flex flex-column gap-2 w-full h-full">
                    <ExamHeader
                        title={exam?.title}
                        exam={exam}
                        startedAt={startedAt}
                        timeLeft={timeLeft}
                        appendTo={appendTo}
                        onFinish={onFinish}
                    />

                    <div className="flex flex-wrap justify-content-center w-full h-full p-4 ">
                        <QuestionCard onFinish={onFinish}/>
                    </div>

                    <QuestionControl/>
                </div>
            </div>
        </div>
    );
};

export default ExamPage;
